import React from 'react';
import Moment from 'moment';
import { useTranslation } from 'react-i18next';

import { useConversionTable } from 'hooks';
import * as Styled from './StyledInvestment';

export function InvestmentCard(props) {
    const { t } = useTranslation('ranking');
    const conv = useConversionTable(['investmentType']);

    const data = props.data || props.investment || undefined;
    const startup = data.startup.data;

    let bold = t('glossary:valueNotDeclared');
    if (data.value) {
        bold = Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: data.value.currency,
        }).format(data.value.amount);
    }

    let text = '';
    if (data.type) {
        text += conv.investmentType[data.type];
    }
    if (data.date) {
        const momentDate = Moment(data.date).utcOffset(data.date);
        const formatDate = momentDate.format('MM/YYYY');
        text += `${text ? ' - ' : ''}${formatDate}`;
    }

    const propsCard = {
        as: data.onClick ? 'button' : undefined,
        onClick: data.onClick,
    };
    return (
        <Styled.InvestmentCard {...propsCard}>
            <Styled.CardImage img={encodeURI(startup.logoUrl)} />
            <Styled.CardInfos>
                <span className="name">{startup.name}</span>
                <span className="bold">{bold}</span>
                <span className="text">{text}</span>
            </Styled.CardInfos>
        </Styled.InvestmentCard>
    );
}
export default InvestmentCard;
